module.exports = __webpack_public_path__ + "img/1_018.b40624c6.jpg";